import styled, { css } from 'styled-components'
import ArrowElement from 'components/shared/StyledComponents/ArrowElement'

const BaseButton = styled.button.withConfig({
	shouldForwardProp: prop => !['loading', 'fWidth', 'inline', 'shrink', 'wMargin'].includes(prop)
})`
  border: none;
	border-radius: 4px;
	height: 42px;
	color: #fff;
	text-transform: uppercase;
	font-family: Roboto;
	font-size: 14px;
	font-weight: 300;
	padding: ${({ loading }) => !loading ? '8px 15px' : '8px 40px'};
	transition: all 0.3s;
	cursor: pointer;
	width: ${props => props.fWidth ? '100%' : 'unset'};
	min-width: ${props => props.shrink ? '140px' : props.fWidth ? '0' : '180px'};
	margin-left: ${props => props.wMargin ? '20px' : 'unset'};
	position: relative;
	&:hover {
		box-shadow: 0 2px 2px 0 rgba(151, 151, 151, 0.35);
	}
	svg {
		margin: 0 0.3em 0 0;
		font-size: 0.8em;
		&.loading-ico {
			width: 22px;
			height: 22px;
			margin: 0;
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
		}
		g, path {
			fill: ${({ theme, status }) => status !== 'primary' && theme.primaryColor};
		}
	}
	&:focus {
		outline: none;
	}
	// Workaround for '& + &:not(.fWidth)'
	${props => !props.fWidth && css`
		& + ${() => BaseButton} {
			margin-left: 20px;
		}
	`}
`
export const PrimaryButton = styled(BaseButton)`
	background-color: ${props => props.theme.primaryColor};
	&:hover {
		background-color: ${props => props.theme.primaryHover};
	}
`
export const ActiveButton = styled(BaseButton)`
	background-color: ${props => props.theme.activeColor};
`
export const withDropdownArrow = Component => styled(Component)`
	&:after {
		content: '';
		border-style: solid;
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		border-width: ${({ isOpen }) => isOpen ? '0 4.5px 6px' : '6px 4.5px 0'};
		border-color: ${({ theme, isOpen }) => isOpen ?
		`transparent transparent ${theme.primaryColor}` :
		`${theme.primaryColor} transparent transparent`};
	}
`
export const DropdownButton = withDropdownArrow(styled(BaseButton)`
	position: relative;
	text-transform: capitalize;
	margin: 0;
	padding: 3px 30px 3px 10px;
	text-align: center;
	min-width: 75px;
	cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
	opacity: ${({ disabled }) => disabled ? 0.5 : 1};
	height: 22px;
	font-size: 14px;
	background-color: ${props => props.theme.darkbgColor};
	box-shadow: 0 1px 2px 0 rgba(90, 90, 90, 0.2);
	border-radius: 3px;
	color: ${props => props.theme.primaryColor};
	${props => ArrowElement({ color: props.theme.primaryColor })}
`)
export const InactiveButton = styled(BaseButton)`
	background-color: ${props => props.theme.inactiveColor};
	cursor: not-allowed;
`
export const GreenButton = styled(BaseButton)`
	background-color: ${props => props.theme.greenColor};
	// cursor: not-allowed;
`
export const LinkButton = styled(BaseButton)`
	background-color: transparent;
	color: ${props => props.theme.fieldLabelColor};
	text-decoration: underline;
	&:hover {
		color: ${props => props.theme.primaryColor};
	}
`
export const CancelButton = styled(BaseButton)`
	background-color: #fff;
	color: ${props => props.theme.primaryColor};
`

export const TransparentButton = styled(BaseButton)`
  background-color: #fff;
  color: ${props => props.theme.primaryColor};
  border: 1px solid ${props => props.theme.primaryColor};
	margin: 36px 0 18px 0;
	&:hover {
		background-color: ${props => props.theme.primaryColor};
		color: #fff;
	}
`
